import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { Hub } from '../../../components';
import { CaptionText, H2, P1, P2, P3 } from '../../../styles/FontStyles';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { PurchaseSteps } from '../Maeketplace.types';

interface PaymentMethodProps {
  setStep: Dispatch<SetStateAction<PurchaseSteps>>;
  selectedPackage: any;
  selectedLicence: any;
  setUsdt: Dispatch<SetStateAction<string>>;
  setUsdc: Dispatch<SetStateAction<string>>;
}

export const PaymentMethod = ({
  setStep,
  selectedPackage,
  selectedLicence,
  setUsdt,
  setUsdc
}: PaymentMethodProps) => {
  const { t } = useTranslation('marketplace');

  if (!selectedPackage?.packageId) return null;

  const showButtonText = () => {
    if (selectedLicence === null && packageId >= 170) {
      return 'Pay with USDT and CLUB balance';
    }
    if (selectedLicence === null && packageId >= 150) {
      return 'Pay with USDT, CLUB and LP balance';
    } else {
      return 'Pay with USDT and CLUB balance';
    }
  };

  const {
    packageId,
    image,
    name,
    price,
    weeklyCap,
    limitedQuantity,
    tradingBinaryPercentage,
    calculator,
    willyMemeCoins,
    subtitle,
    tickets,
    subscriptionPrice
  } = selectedPackage;

  const amountToPay = selectedLicence
    ? subscriptionPrice
      ? selectedLicence.price + price + subscriptionPrice
      : selectedLicence.price + price
    : subscriptionPrice
    ? subscriptionPrice + price
    : price;

  return (
    <div>
      <P1 bold mb={'20'}>
        {t('selected_staking_hub_nft')}:
      </P1>

      <Hub
        key={packageId}
        condensed
        image={image}
        title={name}
        price={subscriptionPrice ? price : amountToPay}
        subscriptionPrice={subscriptionPrice}
        selectedLicence={selectedLicence}
        subtitle={subtitle}
        tickets={tickets}
        packagePrice={price}
        weeklyCap={weeklyCap}
        limitedQuantity={limitedQuantity}
        dobuleTradingBinaries={tradingBinaryPercentage}
        includesSubscription={selectedLicence?.access}
        willyMemeCoins={willyMemeCoins}
        showTickets={packageId >= 170 && packageId < 180}
        info={
          <>
            {calculator && (
              <Flexed alignEnd end>
                <H2 bold mr='16' alignEnd>
                  {calculator}
                </H2>
                <CaptionText bold right mb='4'>
                  {t('reward')}
                  <br />
                  {t('multiplicator')}
                </CaptionText>
              </Flexed>
            )}
          </>
        }
      />

      <P2 mb={'20'} mt={'40'}>
        Technology & Travel of the future is being built today. Position
        yourself as one of those who saw the change coming, before others didn’t
        even dare to dream.
      </P2>

      {/* MIXED PAYMENT */}
      <Button mb={20} onClick={() => setStep(PurchaseSteps.PAY_MIXED)}>
        {showButtonText()}
      </Button>
      {/* MIXED PAYMENT */}

      <Button
        negative
        mb={20}
        onClick={() => {
          setStep(PurchaseSteps.PAY_TETHER);

          // setUsdt(amountToPay.toString());
        }}>
        {t('pay_with_tether')}
      </Button>
    </div>
  );
};
